import Footer from "@/components/Footer"
import Header from "@/components/Header"
import Password from "@/components/User/Password"
import { NextPage } from "next/types"


const PasswordPage: NextPage = () => {


  return (
    <>
      <Header />
      <Password />
      <Footer />
    </>
  )
}

export default PasswordPage
